// src/features/projectsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const singleProject = createSlice({
  name: 'singleProject',
  initialState: {
    singleProject: [],
    singleStatus: 'idle',
    singleError: null
  },
  reducers: {
    setSingleProject: (state, action) => {
      console.log('Setting Single project in slice:', action.payload);
      state.singleProject = action.payload;
      state.singleStatus = 'succeeded';
      state.singleError = null;
    },
    setError: (state, action) => {
      state.singleError = action.payload;
      state.singleStatus = 'failed';
    },
    clearProject: (state) => {
      state.singleProject = [];
      state.singleStatus = 'idle';
      state.singleError = null;
    }
  }
});

export const { setSingleProject, setError, clearProject } = singleProject.actions;


// export const selectProjectsStatus = (state) => state.projects.singleStatus;
// export const selectProjectsError = (state) => state.projects.singleError;

export default singleProject.reducer;